import React from 'react'
import type { Toll } from '../../../../../types'
import { createColumnHelper } from '@tanstack/react-table'
import { TranslatedText } from '@staccx/i18n'
import { getConsolidateInvoiceDescription } from '../../../../../utils/getConsolidateInvoiceDescription'
import { formatCurrency, formatNumber } from '../../../../../utils/tableFuncs'

export default function tollReportData(chosenCompany?: string) {
  const columnHelper = createColumnHelper<Toll>()
  return [
    columnHelper.accessor(undefined, {
      id: 'period',
      meta: { alignmentType: 'string' },
      header: () => <TranslatedText i18nKey={'PERIOD'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => `Last 2 years` || ''
    }),
    columnHelper.accessor('consolidatedInvoiceAgreement', {
      id: 'consolidatedInvoiceAgreement',
      meta: { alignmentType: 'string' },
      header: () => (
        <TranslatedText i18nKey={'CONSOLIDATED_AGREEMENT'}>{(value) => <span>{value}</span>}</TranslatedText>
      ),
      cell: (row) => row.getValue() || ''
    }),
    columnHelper.accessor('amountIncVAT', {
      id: 'amountIncVAT',
      header: () => <TranslatedText i18nKey={'CURRENCY_VALUE'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => formatCurrency(row.getValue()) || '',
      footer: (props) => props.column.id,
      meta: { alignmentType: 'number' }
    }),
    columnHelper.accessor('antallPasseringer', {
      id: 'antallPasseringer',
      header: () => <TranslatedText i18nKey={'PASSINGS'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => formatNumber(row.getValue(), { precision: 0 }) || '',
      footer: (props) => props.column.id,
      meta: { alignmentType: 'number' }
    })
  ]
}
